export default __webpack_public_path__ + "static/media/portisIcon.7b7769bd.svg";